import React from "react";
import {observer, inject} from "mobx-react";
import {observable} from "mobx";
import UserEdit from "./UserEdit";
import ChooseCustomer from "./ChooseCustomer";
import CustomerOrderHistory from "./CustomerOrderHistory";
import CustomerOrderCopyDocument from "./CustomerOrderCopyDocument";
import CustomerOrderCopies from "./CustomerOrderCopies";
import PersonalOrderCopies from "./PersonalOrderCopies";
import MyProfile from "./MyProfile";
import CustomerInvoices from "./CustomerInvoices";
import CustomerAccount from "./CustomerAccount";
import CustomerAddresses from "./CustomerAddresses";
import CustomerUsers from "./CustomerUsers";
import CustomerAdmin from "./CustomerAdmin";
import CustomerList from "./CustomerList";
import ErrorBoundry from "@components/ErrorBoundry/ErrorBoundry";
//import ComplaintEdit from "./ComplaintEdit";
import PriceList from "./PriceList";
import Logout from "./Logout";
import Login from "./FormikLogin"
import {getRoot} from "mobx-state-tree";



@inject("store")
@observer
export default class BerikssonMyPages extends React.Component {
    @observable viewHeight = 0;
    @observable hidden = true;
    @observable componentName = "";

    constructor(props) {
        super(props);
        this.onResize = this.onResize.bind(this);

        this.Components = {
            UserEdit: UserEdit,
            ChooseCustomer: ChooseCustomer,
            PriceList: PriceList,
            CustomerOrderHistory: CustomerOrderHistory,
            CustomerOrderCopyDocument: CustomerOrderCopyDocument,
            CustomerOrderCopies: CustomerOrderCopies,
            CustomerInvoices: CustomerInvoices,
            CustomerAccount: CustomerAccount,
            CustomerAddresses: CustomerAddresses,
            CustomerUsers: CustomerUsers,
            CustomerAdmin: CustomerAdmin,
            CustomerList: CustomerList,
            PersonalOrderCopies: PersonalOrderCopies,
            MyProfile: MyProfile,
            //Complaints: Complaints,
            //ComplaintEdit: ComplaintEdit,
            Logout: Logout,
            Login: Login
        }
    }

    //componentWillMount() {

    //    this.componentName = this.props.component;
    //    let delay = 0;
    //    if (this.componentName.indexOf(":") > -1) {
    //        const arr = this.componentName.split(":");
    //        this.componentName = arr[0];
    //        delay = arr[1];
    //    }

    //    var that = this;
    //    if (delay > 0) {
    //        setTimeout(() => { that.hidden = false; }, delay);
    //    } else {
    //        this.hidden = false;
    //    }

    //}

    componentDidMount() {
        this.componentName = this.props.component;
        let delay = 0;
        if (this.componentName.indexOf(":") > -1) {
            const arr = this.componentName.split(":");
            this.componentName = arr[0];
            delay = arr[1];
        }

        var that = this;
        if (delay > 0) {
            setTimeout(() => {
                that.hidden = false;
            }, delay);
        } else {
            this.hidden = false;
        }

    }


    //componentDidUpdate() {
    //    const { match } = this.props;
    //    //if (match.isExact) {
    //    ////	this.viewHeigth = 0;
    //    //	//this.props.store.navigation.updateViewHeight(0);
    //    //}


    //    this.componentName = this.props.component;
    //    let delay = 0;
    //    if (this.componentName.indexOf(":") > -1) {
    //        const arr = this.componentName.split(":");
    //        this.componentName = arr[0];
    //        delay = arr[1];
    //    }

    //    var that = this;
    //    if (delay > 0) {
    //        setTimeout(() => { that.hidden = false; }, delay);
    //    } else {
    //        this.hidden = false;
    //    }
    //}


    onResize(w, h) {
        console.log("onResize", h);
        this.viewHeight = h;
        //this.props.store.navigation.updateViewHeight(h);
    }

    render() {
        //console.log("component", this.props.component);
        const Component = this.Components.hasOwnProperty(this.props.component) ? this.Components[this.props.component] : null;

        return (
            <MyPagesMaster>
                <ErrorBoundry>
                    {Component && <Component {...this.props} />}
                    {!Component && ("Error, could not find component: " + this.props.component)} 
                </ErrorBoundry>
            </MyPagesMaster>
        );

    }
}


@inject("store")
@observer
class MyPagesMaster extends React.Component {
    constructor(props) {
        super(props);

        const serverRender = typeof window === 'undefined';
        this.state = {};
    }

    scrollToTop(reason) {
        const serverRender = typeof window === 'undefined';
        if (serverRender) return;

        //console.log("scrollToTop:" + reason, this.ref.current);
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        //this.scrollToTop("didMount myPages");
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log("pageContent update", prevProps, prevState, this.props.store.navigation.pageContent === prevProps.store.navigation.pageContent);
        if (this.props.store.navigation.pageContent && this.props.store.navigation.pageContent.Url !== this.previousUrl) {
            //this.scrollToTop("didUpdate myPages");
            this.previousUrl = this.props.store.navigation.pageContent.Url;
        }
    }
    
    getRootNode(node) {
        if(node.Parent !=  null){
            return this.getRootNode(node.Parent);
        }
        else{
            return node;
        }
    }
    
    
    renderLevel(node, currentNode) {
        return (<ul className="nav">
            {node.Children.map(childPage => {
                return (
                    <li
                        key={"child_" + childPage.Id}
                        className="nav-item"><a className={"nav-link " + (childPage.Id === currentNode.Id ? "active" : "")} href={childPage.Url}>{childPage.Name}</a>
                        {childPage.Children && childPage.Children.length > 0 && this.renderLevel(childPage, currentNode) }
                    </li>
                
                );
            })}
        </ul>);
    }

    render() {
        const currentNode = this.props.store.navigation.CurrentNode;
        const root = this.getRootNode(currentNode);
        
        const parent = currentNode ? currentNode.Parent : null;
        return (this.props.children);
            
            // <div>
            //
            //
            //
            //     <div className={"container"}>
            //         <div className={"row"}>
            //             <div className={"col-md-3"}>
            //                 {this.renderLevel(root, currentNode )}
            //             </div>
            //             <div className={"col-md-9"}>
            //                 {this.props.children}
            //             </div>
            //         </div>
            //     </div>
            // </div>
                
        //);
    }
}









